export default __webpack_public_path__ + "static/media/colored-gas-claim-transaction.af3e2894.svg";